import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/AsideMenu.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/footer/FooterLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/footer/FooterToggleLanguage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/FunctionWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/header/HamburgerButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/header/NavSearch.js");
;
import(/* webpackMode: "eager" */ "/snv/components/layout/Layout.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/modal/AdultConfirmModal.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/modal/ModalInner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/StoreProvider.js");
;
import(/* webpackMode: "eager" */ "/snv/components/TranslationsProvider.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/snv/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/snv/styles/global.scss");
